"use strict";
angular.module("playVideoServiceModule", [
    "playVideoModule",
]).
factory("playVideoService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [createProduct description] 视频播放服务
         * @param {[boolean]} [id] [description] 视频的id
         * @param {[string]} [type] [description] 是否是视频
         * @param {[string]} [isBackstage] [description] 是否是后台
         */
        openPlayVideoPage: function(id,type,isBackstage) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./utils/playVideo/playVideo_tpl.html",
                windowClass: 'playVideo',
                backdrop: false,
                controller: "playVideoCtrl",
                resolve: {
                    id: function() {
                        return id;
                    },
                    type:function(){
                    	return type;
                    },
                    isBackstage:function(){
                    	return isBackstage
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);